import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import api from '@/api'

import landing from './landing'
// import dashboard from './dashboard'
import login from './login'
import paymentScreen from './dashboard/modules/paymentScreen'
import {
  newOrderSelectTariff,
  newOrder,
  newOrderV2,
  newOrderV4,
  newOrderTariff,
  welcomeSetSuccessPage,
} from './newOrder'
import longateBonus from './longation'
import { notFoundRoute, redirectNotFoundRoute } from './notFound'
import { mobAppPaymentResult } from './mobAppPaymentResult'
import redirect from './redirect'

import { APPMETRICA } from '@/config/constants.js'

import technicalCustomizations from '@/config/technicalCustomizations.js'
import detector from '@/services/device-detector'

const routes = [
  login,
  landing,
  paymentScreen,
  newOrderSelectTariff,
  newOrder,
  newOrderV2,
  newOrderV4,
  newOrderTariff,
  welcomeSetSuccessPage,
  notFoundRoute,
  redirectNotFoundRoute,
  mobAppPaymentResult,
  longateBonus,
  redirect,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // console.log('scrollBehavior', to)
    // if (to.hash) {
    //   console.log('scrollBehavior', to.hash)
    //   return {
    //     el: to.hash,
    //     behavior: 'smooth',
    //   }
    // }
    return new Promise((resolve, reject) => {
      if (to?.hash) {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
          })
        }, 150)
      } else {
        resolve()
      }
    })
  },
})

router.afterEach((to, from) => {
  // Mindbox integration logic. See https://developers.mindbox.ru/docs/трекер
  // eslint-disable-next-line no-unused-expressions
  window.PopMechanic?.update?.()
})

/**
 * @description Глобальные запросы инициализируются в beforeEach, для активации глобального запроса для роута необходимо выставить meta: {}
 */
router.beforeEach(async (to, from, next) => {
  if (to.query.promocode) {
    store.dispatch('promocode/setPromocode', to.query.promocode)
  }
  // авторизация по токену
  const clientToken = to.query.t || to.query.ct
  if (clientToken) {
    store.dispatch('client/setToken', clientToken)
  }
  // Временная заглушка для редиректов на lk
  if (
    to.path.indexOf('/dashboard') >= 0 ||
    to.path.indexOf('/new-dashboard') >= 0 ||
    to.path.indexOf('/marketing_activity') >= 0 ||
    to.path.indexOf('/settings') >= 0 ||
    to.path.indexOf('/preferences') >= 0 ||
    to.path.indexOf('/login') >= 0
  ) {
    if (api.REDIRECT_TO_OLD_SITE_URL()) {
      api.redirectToOldSite({
        path: to.href,
      })
      return
    }
  }
  if (
    (
      store.getters['marketing/specificQueryParams'] === technicalCustomizations.inviterGf ||
      to.query.invite
    ) &&
    detector.isSmartphone
  ) {
    const invite = to.query.invite || store.getters['marketing/specificQueryParams'].invite
    const redirectLink = `${APPMETRICA}?utm_medium=invite&utm_source=invite&utm_campaign=${invite}&refPromocode=${invite}`
    window.location.replace(redirectLink)
  }

  // vcp
  if (to?.meta?.requiredVcp) {
    console.log('requiredVcp')
    await store.dispatch('vcp/getVcpConfig')
  }
  if (from.name !== to.name) {
    store.dispatch('abtesting/processSiteDepartmentChange')
  }
  // /vcp
  // goals
  if (to?.meta?.requiredGoals) {
    store.dispatch('goals/getAndSetMenuGoals')
  }
  // /goals
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['client/isLoggedIn'] && to.path !== '/') {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
